import { Routes } from '@angular/router';
import { authGuard } from '../shared/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadComponent: () => import('./pages/auth-landing/auth-landing').then(m => m.AuthLandingComponent),
  },
  {
    path: 'home',
    loadComponent: () => import('./pages/home/home').then(m => m.HomeComponent),
    canActivate: [authGuard],
    data: { background: 'surface' },
  },
  {
    path: 'storico-richieste',
    loadComponent: () => import('./pages/request-list/request-list').then(m => m.RequestListComponent),
    canActivate: [authGuard],
    data: { background: 'surface' },
  },
  {
    path: 'nuova-richiesta',
    loadComponent: () => import('./pages/request-form/request-form.component').then(m => m.RequestFormComponent),
    canActivate: [authGuard],
  },
  {
    path: 'dettaglio-richiesta/:id',
    loadComponent: () => import('./pages/request-detail/request-detail.component').then(m => m.RequestDetailComponent),
    canActivate: [authGuard],
  },
  {
    path: 'modifica-richiesta/:id',
    loadComponent: () => import('./pages/request-form/request-form.component').then(m => m.RequestFormComponent),
    canActivate: [authGuard],
  },
  {
    path: 'richiesta-inviata',
    loadComponent: () => import('./pages/request-form/request-form-confirm/request-form-confirm.component').then(m => m.RequestFormConfirmComponent),
    canActivate: [authGuard],
    data: { background: 'tertiary' },
  },
  {
    path: 'richiesta-modificata',
    loadComponent: () => import('./pages/request-form/request-form-update-confirm/request-form-update-confirm.component').then(m => m.RequestFormUpdateConfirmComponent),
    canActivate: [authGuard],
    data: { background: 'tertiary' },
  },
  {
    path: 'annulla-richiesta/:id',
    loadComponent: () => import('./pages/request-cancel/request-cancel.component').then(m => m.RequestCancelComponent),
    canActivate: [authGuard],
  },
  {
    path: 'conferma-annulla-richiesta',
    loadComponent: () => import('./pages/request-cancel/request-cancel-confirm/request-cancel-confirm.component').then(m => m.RequestCancelConfirmComponent),
    canActivate: [authGuard],
    data: { background: 'tertiary' },
  }
];
